export enum ProductCategoryIcon {
  CATEGORY_BRANDSCHUTZ = "category-brandschutz",
  CATEGORY_FILTERAUSLAESSE = "category-filterauslaesse",
  CATEGORY_LUEFTUNGSGITTER = "category-lueftungsgitter",
  CATEGORY_LUFTAUSLAESSE = "category-luftauslaesse",
  CATEGORY_LUFTKLAPPEN = "category-luftklappen",
  CATEGORY_LUWA = "category-luwa",
  CATEGORY_REGELGERAETE = "category-regelgeraete",
  CATEGORY_SCHALLDAEMPFUNG = "category-schalldaempfung",
  CATEGORY_SPARE = "category-spare",
  CATEGORY_STEUERUNGEN = "category-steuerungen",
  CATEGORY_ZUBEHOER = "category-zubehoer"
}
